// 摄像头评估详情
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
import columns from './columns'
import exportExcel from './excelColumn'
const { WizSpin, WizButton, WizModal, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../../header'

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/cameraEvaluation/detail') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackCameraEvaluationDetail', record)
    } else {
      record = Session.get('trackCameraEvaluationDetail') || {}
    }
  }
  return record
}

class TrackCameraEvaluationDetail extends WizContainer {

  componentName = 'TrackCameraEvaluationDetail'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      data: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, rowInfo } = this.state.record
    this.doAction({
      path: 'counselingProcess/cameraLookCheckList',
      payload: {
        key: 'cameraLookCheckList@' + processContentId,
        apiParams: {
          id: rowInfo.id
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取摄像头详情列表失败')
    return false
  }

  _onBtn = (type) => {
    switch (type) {
      case 1:
        let path = '/integrationCounseling/manager/track/cameraEvaluation/comment'
        let { record } = this.state
        this.jumpPage('push', path, { ...record })
        break
      case 2:
        let { data } = this.state
        exportExcel(data)
        break
      default:
        break
    }
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { record, data } = this.state
    let { rowInfo, processContentState } = record
    let tableProps = {
      columns: columns,
      dataSource: data,
      pagination: false,
      bordered: true,
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='摄像头检核详情'>
          <div style={{ marginBottom: 20 }}>
            <WizButton
              disabled={data.length === 0}
              onClick={() => this._onBtn(2)}>
              {'导出'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'cameraLookCheckList@' + processContentId)
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackCameraEvaluationDetail)
